var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52505 15.3504C1.52505 15.3504 0.300049 15.3504 0.300049 14.1254C0.300049 12.9004 1.52505 9.22539 7.65005 9.22539C13.775 9.22539 15 12.9004 15 14.1254C15 15.3504 13.775 15.3504 13.775 15.3504H1.52505Z",
    fill: "#005182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65005 8.00039C9.67969 8.00039 11.325 6.35504 11.325 4.32539C11.325 2.29574 9.67969 0.650391 7.65005 0.650391C5.6204 0.650391 3.97505 2.29574 3.97505 4.32539C3.97505 6.35504 5.6204 8.00039 7.65005 8.00039Z",
    fill: "#005182"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/person-fill.8115740a8390645ccd1897e2893ca568.svg";
export { ForwardRef as ReactComponent };